import {
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  CREATE_EMPLOYEE,
  UPDATE_EMPLOYEE,
  DELETE_EMPLOYEE,
  CREATE_EMPLOYEE_REQUEST,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_FAILURE,
  UPDATE_EMPLOYEE_REQUEST,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_FAILURE,
  DELETE_EMPLOYEE_REQUEST,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAILURE
} from '../../types/employee/employeeTypes';

const initialState = {
  employees: [],
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEES_REQUEST:
      return { ...state, loading: true };

    case FETCH_EMPLOYEES_SUCCESS:
      return { ...state, loading: false, employees: action.payload };

    case FETCH_EMPLOYEES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Create loading states
    case CREATE_EMPLOYEE_REQUEST:
      return { ...state, createLoading: true };

    case CREATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        employees: [...state.employees, action.payload]
      };

    case CREATE_EMPLOYEE_FAILURE:
      return { ...state, createLoading: false, error: action.payload };

    // Update loading states
    case UPDATE_EMPLOYEE_REQUEST:
      return { ...state, updateLoading: true };

    case UPDATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        employees: state.employees.map((e) =>
          e.id === action.payload.id ? { ...e, ...action.payload.data } : e
        )
      };

    case UPDATE_EMPLOYEE_FAILURE:
      return { ...state, updateLoading: false, error: action.payload };

    // Delete loading states
    case DELETE_EMPLOYEE_REQUEST:
      return { ...state, deleteLoading: true };

    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        employees: state.employees.filter((e) => e.id !== action.payload)
      };

    case DELETE_EMPLOYEE_FAILURE:
      return { ...state, deleteLoading: false, error: action.payload };

    // Legacy cases for backward compatibility
    case CREATE_EMPLOYEE:
      return {
        ...state,
        employees: [...state.employees, action.payload],
      };

    case DELETE_EMPLOYEE:
      return {
        ...state,
        employees: state.employees.filter((e) => e.id !== action.payload),
      };

    case UPDATE_EMPLOYEE:
      return {
        ...state,
        employees: state.employees.map((e) =>
          e.id === action.payload.id ? { ...e, ...action.payload.data } : e
        ),
      };

    default:
      return state;
  }
};

export default employeeReducer;
